import {
  MDBIcon,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
  MDBTimepicker,
} from "mdb-react-ui-kit";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { getStreamsProductName } from "../../../apiclients/CommonUtils";
import { Tooltip } from "react-tooltip";
import Voice1 from "../../../uimedia/sounds/buzz.mp3"
import Voice2 from "../../../uimedia/sounds/chimedwn.mp3"
import Voice3 from "../../../uimedia/sounds/door.mp3"
import Voice4 from "../../../uimedia/sounds/knock.mp3"

function UserStreamsNotification({
  register,
  soundList,
  watch,
  errors,
  clearErrors,
  setValue,
  hideGlobalNotifications,
}) {
  const { t, i18n } = useTranslation();
  const streamsProductName = getStreamsProductName();
  const isStreamsSettingReq = JSON.parse(sessionStorage.getItem("admin_session"))?.isStreamsSettingReq ?? 0;

  // Map sound IDs to their audio files
  const soundMap = {
    1: Voice1,  // buzz
    2: Voice2,  // chimedown
    3: Voice3,  // door
    4: Voice4   // knock
  };
  // Separate refs and states for each audio player
  const newMsgAudioRef = useRef(null);
  const connectAudioRef = useRef(null);
  const [isNewMsgPlaying, setIsNewMsgPlaying] = useState(false);
  const [isConnectPlaying, setIsConnectPlaying] = useState(false);
  const handlePlayAudio = (audioType) => (e) => {
    e.preventDefault();
    e.stopPropagation();

    const isNewMsg = audioType === 'newMsg';
    const selectedSound = watch(
      isNewMsg
        ? "streams_notifications.new_msg_sound"
        : "streams_notifications.connect_IM_invite_sound"
    );
    const audioUrl = soundMap[selectedSound];
    const audioRef = isNewMsg ? newMsgAudioRef : connectAudioRef;
    const isPlaying = isNewMsg ? isNewMsgPlaying : isConnectPlaying;
    const setIsPlaying = isNewMsg ? setIsNewMsgPlaying : setIsConnectPlaying;

    if (!audioUrl) return;

    if (audioRef.current) {
      if (isPlaying) {
        // If already playing, pause it
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        setIsPlaying(false);
      } else {
        // Play the selected sound
        audioRef.current.src = audioUrl;
        audioRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const handleAudioEnd = (audioType) => () => {
    if (audioType === 'newMsg') {
      setIsNewMsgPlaying(false);
    } else {
      setIsConnectPlaying(false);
    }
  };

  const handleDropdownChange = (audioType) => () => {
    const isNewMsg = audioType === 'newMsg';
    const audioRef = isNewMsg ? newMsgAudioRef : connectAudioRef;
    const setIsPlaying = isNewMsg ? setIsNewMsgPlaying : setIsConnectPlaying;

    // Stop any currently playing audio when dropdown changes
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setIsPlaying(false);
    }
  };

  // Get the current selected sound values
  const newMsgSound = watch("streams_notifications.new_msg_sound");
  const connectSound = watch("streams_notifications.connect_IM_invite_sound");
  const showNewMsgPlayButton = newMsgSound && newMsgSound !== -1;
  const showConnectPlayButton = connectSound && connectSound !== -1;

  return (
    <>
      <div className="routing-border mt-2"></div>
      <div className="general-settings" id="Notifications">
        {t("Notifications")}
      </div>
      <div>
        <div className="add-numbermain">
          <div className="tel-numbers">{t("Muteallnotifi")}</div>

          <div className="phoneselect">
            <label className="switch">
              <input
                className="form-control"
                type="checkbox"
                {...register("streams_notifications.mute_all_notifications")}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>
        {watch("streams_notifications.mute_all_notifications") &&
          <div className="add-numbermain">
            <div className="tel-numbers">{t("incUnreadAlert")}
              <MDBIcon fas icon="info-circle" className="ms-2 incUnreadAlert" />
            </div>


            <div className="phoneselect">
              <label className="switch">
                <input
                  className="form-control"
                  type="checkbox"
                  {...register("streams_notifications.inc_unread_alert_muteall")}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        }
        {!watch("streams_notifications.mute_all_notifications") && (
          <>
            <div className="add-numbermain">
              <div className="tel-numbers">{t("ShownotifStreamsDesktop", { "PRODUCT_NAME": streamsProductName })}</div>

              <div className="phoneselect">
                <label className="switch">
                  <input
                    className="form-control"
                    type="checkbox"
                    {...register("streams_notifications.desktop_notifications")}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
            <div className="add-numbermain">
              <div className="tel-numbers">{t("ShownotifStreamsMob", { "PRODUCT_NAME": streamsProductName })}</div>

              <div className="phoneselect">
                <label className="switch">
                  <input
                    className="form-control"
                    type="checkbox"
                    {...register("streams_notifications.mobile_notifications")}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
          </>
        )}

        {!watch("streams_notifications.mute_all_notifications") && (
          <>
            <div className="add-numbermain">
              <div className="tel-numbers">{t("DisablenotifiLikes")}</div>

              <div className="phoneselect">
                <label className="switch">
                  <input
                    className="form-control"
                    type="checkbox"
                    {...register(
                      "streams_notifications.disable_notifications_likes"
                    )}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
            <div className="add-numbermain">
              <div className="tel-numbers">{t("Soundnewmess")}</div>
              <div className="position-relative w-30">

                {showNewMsgPlayButton && (
                  <MDBIcon
                  far
                  icon={isNewMsgPlaying ? "pause-circle" : "play-circle"}
                  size="lg"
                  color="primary"
                  className="me-3 PlayToolTipNewMsg"
                  style={{ cursor: "pointer" }}
                  onClick={handlePlayAudio('newMsg')}
                  />
                )} 
              <div className="phoneselect w-100 d-flex flex-row align-items-center">
                <select
                  className="form-control form-select selectname w-100"
                  name="San Jose"
                  {...register("streams_notifications.new_msg_sound", {
                    setValueAs: (value) => Number(value),
                  })}
                  onChange={(e) => {
                    handleDropdownChange("newMsg");
                    setValue("streams_notifications.new_msg_sound", Number(e.target.value), {
                      shouldDirty: true,
                    });
                  }}
                >
                  <option value={-1}>None</option>
                  {Object.entries(soundList).map(([key, value]) => (
                    <option value={key}>{value}</option>
                  ))}
                </select>
              </div>
            </div>
            </div>
            <div className="add-numbermain">
              <div className="tel-numbers">{t("SoundConnectinvite")}</div>
               <div className="position-relative w-30">
                              {showConnectPlayButton && (
                  <MDBIcon
                    far
                    icon={isConnectPlaying ? "pause-circle" : "play-circle"}
                    size="lg"
                    color="primary"
                    className="me-3 PlayToolTipConnect"
                    style={{ cursor: "pointer" }}
                    onClick={handlePlayAudio('connect')}
                  />
                )}
              < div className="phoneselect w-100 d-flex flex-row align-items-center">

                <select
                  className="form-control form-select selectname w-100"
                  name="Knock"
                  {...register(
                    "streams_notifications.connect_IM_invite_sound",
                    {
                      setValueAs: (value) => Number(value),
                    }
                  )}
                  onChange={(e) => {
                    handleDropdownChange("connect");
                    setValue("streams_notifications.connect_IM_invite_sound", Number(e.target.value), {
                      shouldDirty: true,
                    });
                  }}
                >
                  <option value={-1}>None</option>
                  {Object.entries(soundList).map(([key, value]) => (
                    <option value={key}>{value}</option>
                  ))}
                </select>
              </div>
            </div>
            </div>

            <div className="hoverBg rounded-3">

              <div className="add-numbermain noHoverBg align-items-start mb-0 ">
              <div className="tel-numbers">{t("Disablenotifidaily")}</div>

              <div className=" d-flex align-items-end flex-column">
                <div className="phoneselect mb-2">
                  <label className="switch">
                    <input
                      className="form-control"
                      type="checkbox"
                      {...register(
                        "streams_notifications.disable_notifications_daily_period"
                      )}
                    />
                    <span className="slider round"></span>
                  </label>
                </div>

                </div>
              </div>

              {watch("streams_notifications.disable_notifications_daily_period") &&
                <div className="add-numbermain noHoverBg align-items-start mt-0">
                  <div className="tel-numbers">{t("incUnreadAlert")}
                    <MDBIcon fas icon="info-circle" className="ms-2 incUnreadAlert2" />
                  </div>

                  <div>
                    <div className="phoneselect">
                      <label className="switch">
                        <input
                          className="form-control"
                          type="checkbox"
                          {...register("streams_notifications.inc_unread_alert_daily")}
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>


                {watch(
                  "streams_notifications.disable_notifications_daily_period"
                ) && (
                    <>
                      <div className="  d-flex  ">
                        <label className="px-2 pt-2">{t("from")}</label>
                        <MDBTimepicker
                          inline
                          label={false}
                          value={
                            watch("streams_notifications.from_time") ?? "12:00 AM"
                          }
                          inputLabel=""
                          onChange={(value) => {
                            clearErrors("streams_notifications.from_time");
                            setValue("streams_notifications.from_time", value, {
                              shouldDirty: true,
                            });
                          }}
                        />
                        {errors?.streams_notifications?.from_time && (
                          <p className="text-danger">
                            {errors?.streams_notifications?.from_time?.message}
                          </p>
                        )}

                        <label className="px-1 pt-2">{t("to")}</label>
                        <MDBTimepicker
                          inline
                          label={false}
                          value={
                            watch("streams_notifications.to_time") ?? "11:59 PM"
                          }
                          inputLabel=""
                          onChange={(value) => {
                            clearErrors("streams_notifications.to_time");
                            setValue("streams_notifications.to_time", value, {
                              shouldDirty: true,
                            });
                          }}
                        />
                        {errors?.streams_notifications?.to_time && (
                          <p className="text-danger">
                            {errors?.streams_notifications?.to_time?.message}
                          </p>
                        )}
                      </div>
                    </>
                  )}

                  </div>
              </div>
              }
            </div>
          </>
        )}

      </div>
      { isStreamsSettingReq === 1 && !hideGlobalNotifications &&
    <><div class="fw-bold py-4">Global Notifications</div> 
      <MDBTable>
        <MDBTableHead>
          <tr>
            <th scope='col'>Notify me when someone</th>
            <th scope='col' className="text-center p-3">Content I own</th>
            <th scope='col' className="text-center">Content shared to me</th>
          </tr>
        </MDBTableHead>
        <MDBTableBody>
          <tr>
            <td scope='row'>Adds Content</td>
            <td className="">
              <div className="phoneselect d-flex align-items-center justify-content-center">
                <label className="switch">
                  <input
                    className="form-control"
                    type="checkbox"
                    {...register("global_notifications.adds_content_owned")}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </td>
            <td>
              <div className="phoneselect d-flex align-items-center justify-content-center">
                <label className="switch">
                  <input
                    className="form-control"
                    type="checkbox"
                    {...register("global_notifications.adds_content_shared")}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </td>
          </tr>
          <tr>
            <td scope='row'>Deletes Content</td>
            <td>
              <div className="phoneselect d-flex align-items-center justify-content-center">
                <label className="switch">
                  <input
                    className="form-control"
                    type="checkbox"
                    {...register("global_notifications.deletes_content_owned")}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </td>
            <td>
              <div className="phoneselect d-flex align-items-center justify-content-center">
                <label className="switch">
                  <input
                    className="form-control"
                    type="checkbox"
                    {...register("global_notifications.deletes_content_shared")}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </td>
          </tr>
          <tr>
            <td scope='row'>Modifies Content</td>
            <td>
              <div className="phoneselect d-flex align-items-center justify-content-center">
                <label className="switch">
                  <input
                    className="form-control"
                    type="checkbox"
                    {...register("global_notifications.modifies_content_owned")}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </td>
            <td>
              <div className="phoneselect d-flex align-items-center justify-content-center">
                <label className="switch">
                  <input
                    className="form-control"
                    type="checkbox"
                    {...register("global_notifications.modifies_content_shared")}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </td>
          </tr>
          <tr>
            <td scope='row'>Downloads Content</td>
            <td>
              <div className="phoneselect d-flex align-items-center justify-content-center">
                <label className="switch">
                  <input
                    className="form-control"
                    type="checkbox"
                    {...register("global_notifications.downloads_content_owned")}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </td>
            <td>
              <div className="phoneselect d-flex align-items-center justify-content-center">
                <label className="switch">
                  <input
                    className="form-control"
                    type="checkbox"
                    {...register("global_notifications.downloads_content_shared")}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </td>
          </tr>
        </MDBTableBody>
      </MDBTable> 

      <div className="routing-border mt-2"></div>
      </>}
      {/* Audio element for Sound for New Messages */}
      <audio ref={newMsgAudioRef} onEnded={handleAudioEnd('newMsg')} />
      {/* Audio element for Sound for Connect Screenshare */}
      <audio ref={connectAudioRef} onEnded={handleAudioEnd('connect')} />
      <Tooltip
        anchorSelect=".PlayToolTip"
        place="top"
        className="exampleTooltip"
      >
        Play
      </Tooltip>
      <Tooltip anchorSelect=".incUnreadAlert" place="top" className="exampleTooltip">
        Select this option to disable unread alert badge count.
      </Tooltip>
      <Tooltip anchorSelect=".incUnreadAlert2" place="top" className="exampleTooltip">
        Select this option to disable unread alert badge count during the selected Start and End time.
      </Tooltip>
    </>
  );
}

export default UserStreamsNotification;
